import axios, { AxiosInstance, AxiosResponse } from "axios";
import { ProductGroup } from "../classes/productGroup";
import { PetType } from "../classes/petType";
import { setupCache } from "axios-cache-interceptor";

let api: AxiosInstance;

const productsApi = {
  setApiKeys(
    inputBaseUrl?: string,
    inputXApiKey?: string,
    inputClientKey?: string
  ): void {
    let baseUrl = process.env.VUE_APP_PRODUCTS_URL;
    let xApiKey = process.env.VUE_APP_PRODUCTS_X_API_KEY;
    let clientKey = process.env.VUE_APP_PRODUCTS_CLIENT_KEY;

    if (inputBaseUrl && inputXApiKey && inputClientKey) {
      baseUrl = inputBaseUrl;
      xApiKey = inputXApiKey;
      clientKey = inputClientKey;
    }

    api = axios.create({
      baseURL: baseUrl,
      timeout: 10000,
      headers: {
        "x-api-key": xApiKey,
        "client-key": clientKey,
      },
    });

    setupCache(api, {
      interpretHeader: false,
      ttl: 1000 * 60 * 15, // Cache for 15 minutes
    });
  },

  async getPetTypes(): Promise<PetType[]> {
    return await api
      .get(`pet-types`, {
        params: {
          include: "breeds",
          sort: "breeds-sort_order,breeds-name",
        },
      })
      .then((result: AxiosResponse) => {
        return result.data.data.map(
          (petType: AxiosResponse) => new PetType(petType)
        );
      })
      .catch(() => {
        return [];
      });
  },

  async getProductGroup(
    productGroup: number,
    petType = 1,
    breedId?: number,
    birthdate?: string,
    startDate?: string,
    showHiddenRates?: boolean
  ): Promise<ProductGroup | undefined> {
    return api
      .get(`product-groups`, {
        params: {
          include:
            "products,products.filteredRates,filteredFeatures,products.filteredFeatureValues,products.sellRelations",
          sort: "products-product_line_id,rates-price",
          "filter[id]": productGroup,
          "filter[rates-pet_type_id]": petType,
          "filter[rates-breeds.identifier]": breedId,
          "filter[rates-birthdate]": birthdate,
          start_date: startDate,
          show_hidden_rates: showHiddenRates ? 1 : undefined,
        },
      })
      .then((result: AxiosResponse) => {
        return new ProductGroup(result.data.data[0]);
      })
      .catch(() => {
        return undefined;
      });
  },
};

export default productsApi;
